import React from "react";
import FormGroup from "features/shared/forms/components/FormGroup";
import IDataFilterProps from "../IDataFilterProps";
import { useTranslation } from "react-i18next";
import { getTranslatedFormText } from "features/shared/helpers/translationHelper";

const DataFilterTextBox = (props: IDataFilterProps) => {
  // translations
  const tLables = useTranslation("shared\\dataFilters").t;

  const handleOnChangeTextBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newDescriptors = [...props.descriptors];

    let descriptor = newDescriptors.find((x) => x.name === e.target.name);
    if (!descriptor) return;

    descriptor!.value = e.target.value;
    props.setDescriptors(newDescriptors);
  };

  return (
    <FormGroup
      inputId={props.filterDescriptor.name}
      labelText={getTranslatedFormText(props.filterDescriptor, "label", tLables)}
      key={props.reactKey}
    >
      <input
        type="text"
        className="form-control"
        id={props.filterDescriptor.name}
        name={props.filterDescriptor.name}
        value={props.filterDescriptor.value || ""}
        aria-describedby="filterInput"
        onChange={handleOnChangeTextBox}
      />
    </FormGroup>
  );
};

export default DataFilterTextBox;
